<template>
    <div class="lg:flex lg:px-12">
        <div class="mx-auto mb-6 lg:mb-0 lg:w-1/2 md:px-12 flex items-center justify-center lg:block">
            <button
                v-for="step in 5"
                :key="step"
                class="flex text-left mb-6 focus:outline-none"
                @click="activeStep = step"
            >
                <span
                    class="shrink-0 text-white text-lg md:text-2xl font-semibold w-10 sm:w-12 h-10 sm:h-12 rounded-full flex items-center justify-center mx-2 lg:ml-0 lg:mr-4"
                    :class="{ 'bg-orange': activeStep !== step, 'bg-teal-darker': activeStep === step }"
                >
                    &check;
                </span>
                <span :class="{ 'text-teal-darker': activeStep === step }" class="hidden lg:block text-lg mt-1 pr-6 leading-tight" v-html="carouselTitles[step - 1]">
                </span>
            </button>
        </div>
        <div class="lg:w-1/2 md:px-12 text-xl">
            <Transition name="slide-fade" mode="out-in">
                <div v-if="activeStep === 1" :key="1" class="flex flex-col md:flex-row items-start">
                    <div class="order-1 md:order-2 w-full text-center lg:text-left mb-12 md:mb-0">
                        <h5 class="text-teal-darker leading-normal font-semibold lg:font-normal text-2xl lg:text-3xl mb-6" v-html="carouselTitles[0]"></h5>
                        <div class="text-lg leading-normal" v-html="carouselBodies[0]"></div>
                    </div>
                </div>
                <div v-else-if="activeStep === 2" :key="2" class="flex flex-col md:flex-row items-start">
                    <div class="order-1 md:order-2 w-full text-center lg:text-left mb-12 md:mb-0">
                        <h5 class="text-teal-darker leading-normal font-semibold lg:font-normal text-2xl lg:text-3xl mb-6" v-html="carouselTitles[1]"></h5>
                        <div class="text-lg leading-normal" v-html="carouselBodies[1]"></div>
                    </div>
                </div>
                <div v-else-if="activeStep === 3" :key="3" class="flex flex-col md:flex-row items-start">
                    <div class="order-1 md:order-2 w-full text-center lg:text-left mb-12 md:mb-0">
                        <h5 class="text-teal-darker leading-normal font-semibold lg:font-normal text-2xl lg:text-3xl mb-6" v-html="carouselTitles[2]"></h5>
                        <div class="text-lg leading-normal" v-html="carouselBodies[2]"></div>
                    </div>
                </div>
                <div v-else-if="activeStep === 4" :key="4" class="flex flex-col md:flex-row items-start">
                    <div class="order-1 md:order-2 w-full text-center lg:text-left mb-12 md:mb-0">
                        <h5 class="text-teal-darker leading-normal font-semibold lg:font-normal text-2xl lg:text-3xl mb-6" v-html="carouselTitles[3]"></h5>
                        <div class="text-lg leading-normal" v-html="carouselBodies[3]"></div>
                    </div>
                </div>
                <div v-else-if="activeStep === 5" :key="5" class="flex flex-col md:flex-row items-start">
                    <div class="order-1 md:order-2 w-full text-center lg:text-left mb-12 md:mb-0">
                        <h5 class="text-teal-darker leading-normal font-semibold lg:font-normal text-2xl lg:text-3xl mb-6" v-html="carouselTitles[4]"></h5>
                        <div class="text-lg leading-normal" v-html="carouselBodies[4]"></div>
                    </div>
                </div>
            </Transition>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    'carouselTitles': null,
    'carouselBodies': null,
  },

  data() {
    return {
      activeStep: 1,
    };
  }
};
</script>
